<template>
  <div class="main_box">
    <div class="main_body">
      <div class="form_bar">
        <div></div>
        <div class="form_bar_btn">
          <el-button
            type="text"
            @click="goBack()"
            v-if="questionnaireInfo.Type === 1"
            >返回问卷列表</el-button
          >
          <el-button
            type="text"
            @click="goBack()"
            v-if="questionnaireInfo.Type === 2"
            >返回投票列表</el-button
          >
          <el-button type="primary" @click="refresh()" size="small" plain>
            刷新
          </el-button>
        </div>
      </div>
      <div class="form_content">
        <div class="questionnaire_name">
          {{ questionnaireProgress.QuestionnaireName }}
        </div>
        <el-divider content-position="left">
          未填写问卷人员（{{ questionnaireProgress.NotSubmitUserList.length }}）
        </el-divider>
        <div class="not_questionnaire_user_box">
          <div
            class="not_questionnaire_user_box_item"
            v-for="(item, index) in questionnaireProgress.NotSubmitUserList"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import questionnaireApi from '../../../../../api/wj/questionnaire'
export default {
  name: 'Progress',
  components: {
  },
  data () {
    return {
      questionnaireProgress: {
        NotSubmitUserList: []
      }
    }
  },
  props: ['questionnaireInfo'],
  methods: {
    goBack: function () {
      if (this.questionnaireInfo.Type === 2) {
        this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
      }
      if (this.questionnaireInfo.Type === 1) {
        this.$router.push({ name: 'questionnaireManage', params: { mid: this.$route.params.mid } })
      }
    },
    getQuestionnaireProgress: function () {
      this.openLoading()
      questionnaireApi.getQuestionnaireProgress({
        questionnaireId: this.$route.params.qid
      }).then(data => {
        this.questionnaireProgress = data
        this.openLoading().close()
      }).catch(err => {
        this.openLoading().close()
        return err
      })
    },
    refresh: function () {
      this.getQuestionnaireProgress()
    }
  },
  computed: {

  },
  created () {
    this.getQuestionnaireProgress()
  }
}
</script>
<style lang="less">
.questionnaire_name {
  width: 100%;
  text-align: center;
  font-size: 24px;
  font-weight: 900;
  padding: 10px;
}
.not_questionnaire_user_box {
  margin: 20px;
  display: -webkit-flex;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.not_questionnaire_user_box_item {
  margin-right: 20px;
  font-weight: 700;
}
.form_content .el-divider__text {
  font-size: 18px;
  font-weight: 900;
}
</style>
